module.exports = __webpack_public_path__ + "img/youtube-shorts.fe928b2b.svg";